// имена категорий собранных данными для отображения анкет.
const categoryForQuestion = {
  // если isMultiple (предназначен для каждого заявителя):
  false: 'common',
  true: 'personal',
}

export default categoryForQuestion;
